import React from 'react'
import "./services.css";

const servicesData = [
    {
        id: 1,
        icon: "uil uil-server-network",
        title: ["Backend &", "APIs"],
        description: "Java and Spring Boot services that are easy to maintain and well documented.",
        items: [
            "REST APIs with OpenAPI / Swagger docs",
            "Microservices behind a Zuul API gateway",
            "Data access with Spring Data JPA",
            "Oracle SQL, plus PostgreSQL, MySQL and Elasticsearch",
        ],
    },
    {
        id: 2,
        icon: "uil uil-plug",
        title: ["Integrations &", "Tooling"],
        description: "Connecting systems to outside services, and building tools that save the team time.",
        items: [
            "Third-party API integrations, including payment gateways and digital wallets",
            "Reliable messaging between systems with RabbitMQ",
            "Plug-and-play Spring Boot libraries the whole team can reuse",
            "Bash scripts and CLI tools that automate repetitive work",
            "Code generators, like a unit test generator for Java",
        ],
    },
    {
        id: 3,
        icon: "uil uil-shield-check",
        title: ["Reliability &", "Security"],
        description: "Keeping systems stable, code clean and sensitive data safe.",
        items: [
            "Encryption for sensitive data",
            "Secure, token-based APIs",
            "API docs ready for security testing",
            "Code that passes SonarQube quality gates",
            "Tuning gateways when traffic gets heavy",
            "Monitoring scripts for database replication",
        ],
    },
];

const Services = () => {
  return (
    <section className="services section" id="services">
        <h2 className="section_title">Services</h2>
        <span className="section_subtitle">What I Offer</span>

        <div className="services_container container grid">
            {servicesData.map((service) => (
                <div className="services_content" key={service.id}>
                    <i className={`${service.icon} services_icon`}></i>
                    <h3 className="services_title">{service.title.join(" ")}</h3>
                    <p className="services_description">{service.description}</p>

                    <ul className="services_list">
                        {service.items.map((item) => (
                            <li className="services_item" key={item}>
                                <i className="uil uil-check-circle services_item-icon"></i>
                                <span>{item}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    </section>
  )
}

export default Services
